import React, { useState } from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import { useFlexSearch } from "react-use-flexsearch"
// import { Formik, Form, Field } from "formik"
import { GoSearch } from "react-icons/go"
import { AiOutlineCloseCircle } from "react-icons/ai"
import { GatsbyImage } from "gatsby-plugin-image"

const Search = () => {
  const data = useStaticQuery(graphql`
    {
      localSearchProducts {
        index
        store
      }
    }
  `)
  const index = data.localSearchProducts.index
  const store = data.localSearchProducts.store
  const [query, setQuery] = useState("")
  const results = useFlexSearch(query, index, store)

  return (
    <div className="lg:col-span-2 col-span-1 mt-4 lg:mt-0">
      <div className="bg-white flex border-primary border shadow-lg shadow-primary/20 items-center rounded-sm min-w-full relative">
        <input
          className="rounded-l-full w-full  px-6 text-gray-700 leading-tight focus:outline-none"
          id="search"
          type="text"
          placeholder="Search"
          value={query}
          autoComplete="off"
          onChange={e => {
            setQuery(e.target.value)
          }}
        />

        {query && (
          <div className="">
            <button
              onClick={() => setQuery("")}
              className="bg-gray-700 absolute top-1 right-8 lg:top-1 lg:right-9   text-white rounded-full  hover:bg-black focus:outline-none w-6  h-6 flex items-center justify-center"
            >
              <AiOutlineCloseCircle className="w-6 h-6" />
            </button>
          </div>
        )}
        <div className="p-1">
          <button className="bg-primary text-white rounded-full p-1 hover:bg-black focus:outline-none w-6 h-6 flex items-center justify-center">
            <GoSearch className="w-4 h-4" />
          </button>
        </div>

        {results.length > 0 && (
          <div className="bg-white absolute inset-0 top-12 z-40 rounded-2xl ">
            <div className="overflow-y-scroll h-screen">
              {results.slice(0, 8).map(p => {
                const getPrice = p.discountPrice ? p.discountPrice : p.price
                return (
                  <Link
                    to={p.path}
                    className="bg-white divide-y divide-red-500 divide-solid px-6 last:divide-y-0 block"
                    key={p.id}
                  >
                    <div className="flex">
                      <div className="w-1/4 rounded-tl-xl flex justify-center">
                        <GatsbyImage
                          image={p.image.asset.gatsbyImageData}
                          alt="search"
                          objectFit="contain"
                        />
                      </div>
                      <div className="p-4 w-3/4">
                        <h3 className="font-bold text-md mb-2 ">{p.title}</h3>
                        <p className="text-sm">
                          {p.discountPrice ? (
                            <span className="line-through  px-2">
                              {p.price}TK
                            </span>
                          ) : (
                            ""
                          )}
                          {getPrice}tk
                        </p>
                      </div>
                    </div>
                    <div></div>
                  </Link>
                )
              })}
            </div>
          </div>
        )}
      </div>
      {/* <div className="p-2 md:hidden block">
        <button className="bg-white text-primary rounded-md p-2 shadow-xl hover:bg-black hover:text-white focus:outline-none w-8 h-8 flex items-center justify-center">
          <GoSearch />
        </button>
      </div> */}
    </div>
  )
}

export default Search
